module.exports = __webpack_public_path__ + "assets/img/paySuccess_icon.054280e3.png";